import Svg from "./figs/Svg";
import image_logo from "./figs/svgs/logo.svg";

export default function HeaderLogo() {
  return (
    <div className="_header_logo">
      {/* <Svg iconName="logo" /> */}
      <img className="logo" src={image_logo} alt="logo"/>
    </div>
  );
}
